import { useState } from 'react';
import { motion } from 'framer-motion';
import { Volume2, VolumeX, ArrowDown } from 'lucide-react';
import { useExperience } from '@/store/experience';
import { audio } from '@/lib/audio';

const GATE = 'SPLittleKnight';

export function PasswordGate() {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const soundOn = useExperience((s) => s.soundOn);
  const setSoundOn = useExperience((s) => s.setSoundOn);
  const setPhase = useExperience((s) => s.setPhase);

  const submit = (e) => {
    e.preventDefault();
    if (value === GATE) { audio.setScene('airplane'); setPhase('JUMPING'); return; }
    setError(true);
    setTimeout(() => setError(false), 2600);
  };
  const toggleSound = async () => { const next = !soundOn; setSoundOn(next); await audio.setEnabled(next); audio.setScene('airplane', 0.5); };

  return (
    <motion.div className="fixed inset-0 z-30 flex items-end sm:items-center justify-center sm:justify-start px-5 sm:px-[8vw] pb-8 sm:pb-0" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0, y: -40, filter: 'blur(10px)', transition: { duration: 0.8 } }} transition={{ duration: 1.2 }} data-testid="password-gate">
      <motion.form onSubmit={submit} className="glass relative w-full max-w-md rounded-[2rem] p-7 sm:p-10 overflow-hidden"
        animate={error ? { x: [0, -8, 8, -5, 5, 0] } : { y: [0, -8, 0] }} transition={error ? { duration: 0.5 } : { duration: 7, repeat: Infinity, ease: 'easeInOut' }}>
        <div className="absolute -top-20 -right-16 w-56 h-56 rounded-full bg-white/10 blur-3xl pointer-events-none" />
        <p className="cloud-eyebrow" data-testid="gate-welcome">Welcome to StorySpark Studios</p>
        <h1 className="cloud-text text-4xl sm:text-5xl lg:text-6xl mt-3" data-testid="gate-title">ENTER<br />THE SKY</h1>
        <p className="mt-4 text-sm text-white/65 max-w-xs">Altitude 14,000 ft. A StorySpark coin is falling through the clouds. Follow it.</p>
        <label className="field-label mt-8" htmlFor="gate-password">Enter password</label>
        <input id="gate-password" type="password" autoComplete="off" value={value} onChange={(e) => setValue(e.target.value)} placeholder="••••••••••" className="glass-input tracking-[0.3em]" data-testid="gate-password-input" />
        <motion.p className="mt-3 h-5 text-xs tracking-[0.2em] font-display uppercase" animate={{ opacity: error ? 1 : 0, y: error ? 0 : -4 }} style={{ color: '#ffd1b3' }} data-testid="gate-error" aria-live="polite">
          {error ? "The clouds don't recognize you yet." : ''}
        </motion.p>
        <div className="mt-5 flex items-center justify-between gap-3">
          <button type="submit" className="btn-cloud primary" data-testid="gate-jump-button" data-cursor="cloud">Jump <ArrowDown size={14} /></button>
          <button type="button" onClick={toggleSound} className="btn-cloud !px-4" aria-label="Toggle sound" data-testid="gate-sound-toggle">
            {soundOn ? <Volume2 size={16} /> : <VolumeX size={16} />}
          </button>
        </div>
      </motion.form>
    </motion.div>
  );
}
